
import { Search, Filter, Grid, List } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { 
  DropdownMenu, 
  DropdownMenuContent, 
  DropdownMenuGroup, 
  DropdownMenuItem, 
  DropdownMenuLabel, 
  DropdownMenuSeparator, 
  DropdownMenuTrigger 
} from "@/components/ui/dropdown-menu";
import { SortOption } from "./types";

interface EntriesControlsProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  sortOption: SortOption;
  onSortChange: (option: SortOption) => void;
  viewMode: 'grid' | 'list';
  onViewModeChange: (mode: 'grid' | 'list') => void;
}

export const EntriesControls = ({ 
  searchTerm, 
  onSearchChange, 
  sortOption, 
  onSortChange,
  viewMode,
  onViewModeChange
}: EntriesControlsProps) => {
  return (
    <div className="flex flex-col sm:flex-row gap-2 sm:items-center">
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-gray-500" />
        <Input
          placeholder="Search entries..."
          className="pl-8 h-9 md:w-[200px] lg:w-[280px]"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      
      <div className="flex items-center gap-2">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="h-9">
              <Filter className="mr-2 h-4 w-4" />
              <span>Sort</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-40">
            <DropdownMenuLabel>Sort By</DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuGroup>
              <DropdownMenuItem 
                onClick={() => onSortChange('newest')}
                className={sortOption === 'newest' ? 'bg-primary/10' : ''}
              >
                Newest First
              </DropdownMenuItem>
              <DropdownMenuItem 
                onClick={() => onSortChange('oldest')}
                className={sortOption === 'oldest' ? 'bg-primary/10' : ''}
              >
                Oldest First
              </DropdownMenuItem>
              <DropdownMenuItem 
                onClick={() => onSortChange('mostLiked')}
                className={sortOption === 'mostLiked' ? 'bg-primary/10' : ''}
              >
                Most Liked
              </DropdownMenuItem>
            </DropdownMenuGroup>
          </DropdownMenuContent>
        </DropdownMenu>
        
        <div className="bg-secondary rounded-md flex">
          <Button 
            variant={viewMode === 'grid' ? "default" : "ghost"} 
            size="sm" 
            onClick={() => onViewModeChange('grid')}
            className="rounded-r-none"
          >
            <Grid className="h-4 w-4" />
          </Button>
          <Button 
            variant={viewMode === 'list' ? "default" : "ghost"} 
            size="sm" 
            onClick={() => onViewModeChange('list')}
            className="rounded-l-none"
          >
            <List className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};
